module.exports = __webpack_public_path__ + "static/media/back.be544580.svg";